import React from "react";
import UserIcon from "@components/icons/User";
import cn from "./helpers/cn";

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  variant?: "circular" | "rounded" | "square";
  size?: "small" | "medium" | "large";
  children?: React.ReactNode; // Para iniciais (ex: "JD")
  component?: React.ElementType;
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>((props, ref) => {
  const {
    src,
    alt,
    variant = "circular",
    size = "small",
    children,
    className,
    component: Component = "span",
    ...other
  } = props;

  // Mapeamento de tamanhos (compatível com a escala do MUI)
  const sizeClasses = {
    small: "w-8 h-8 text-xs",
    medium: "w-10 h-10 text-sm",
    large: "w-14 h-14 text-lg",
  };

  // Mapeamento de formatos
  const variantClasses = {
    circular: "rounded-full",
    rounded: "rounded-md",
    square: "rounded-none",
  };

  const containerClasses = cn(
    "relative flex items-center justify-center shrink-0 overflow-hidden select-none",
    "bg-slate-300 text-slate-600 font-medium uppercase", // Estilo fallback
    sizeClasses[size],
    variantClasses[variant],
    className
  );

  return (
    <Component ref={ref} className={containerClasses} {...other}>
      {src ? (
        <img
          src={src}
          alt={alt}
          className="object-cover text-center text-transparent"
        />
      ) : children ? (
        children
      ) : (
        <UserIcon className="w-2/3 h-2/3" />
      )}
    </Component>
  );
});

Avatar.displayName = "Avatar";

export default Avatar;